import { topicGroups } from '@/mocks/homeData';

export default function TopicWall() {
  return (
    <section id="topics" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-secondary-900">
              <i className="ri-price-tag-3-fill" /> 标签 · 话题墙
            </span>
            <h2 className="mt-2 text-2xl font-extrabold text-foreground-950 md:text-4xl">
              按标签把内容分门别类
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              91免费内容大全的标签墙按吃瓜榜话题、内容大类与素材关键词分区排列，
              想看哪一类就点哪个标签，定位更快更省心。
            </p>
            <a
              href="#feed"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-lg bg-secondary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600"
            >
              <i className="ri-list-unordered" /> 查看最新内容
            </a>
          </div>

          <div className="grid grid-cols-1 gap-5 lg:col-span-3 lg:grid-cols-2">
            {topicGroups.map((group) => (
              <div
                key={group.group}
                className="rounded-2xl border border-background-200 bg-background-100 p-5"
              >
                <div className="flex items-center gap-2">
                  <span className="flex h-2.5 w-2.5 rounded-full bg-accent-500" />
                  <h3 className="text-sm font-bold text-foreground-950">{group.group}</h3>
                </div>
                <p className="mt-1.5 text-xs text-foreground-500">{group.desc}</p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {group.tags.map((tag) => (
                    <a
                      key={tag}
                      href="#feed"
                      className="inline-flex whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700"
                    >
                      {tag}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}